// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import { currencyBySurfaceConvertor } from '../../utils/currencyConvertorUtils';
import type { SelectConvertorMap } from '../../types/commonTypes';

type Props = {
  value: number,
  gla: number,
  quantity: string,
  withSymbol: boolean,
  cookies: Cookies,
  currenciesList: SelectConvertorMap,
  isCurrencyBySurface: boolean,
  mustBeCurrencyBySurface: boolean,
}

function CurrencySurfaceConvertor({
  value, gla, quantity, withSymbol, cookies, currenciesList, isCurrencyBySurface, mustBeCurrencyBySurface,
}: Props) {
  const shouldDivideBySurface = () => mustBeCurrencyBySurface || isCurrencyBySurface;

  return (
    <div className="currency-convertor">
      {currencyBySurfaceConvertor(
          value,
          cookies,
          currenciesList,
          shouldDivideBySurface(),
          gla,
          withSymbol,
          quantity,
        )}
    </div>
  );
}

export default withCookies(connect(state => ({
  currenciesList: state.dynamicKeys.currenciesList,
  isCurrencyBySurface: state.store.isCurrencyBySurface,
}))(CurrencySurfaceConvertor));
